import CCText from './CCText';

export default CCText;
